export default {
  count: (state) => state.favourites?.length ?? 0,
  // eslint-disable-next-line max-len
  getFavourite: (state) => (name, identifier) => state.favourites?.find((f) => f.name === name && f.identifier === identifier) ?? null,
};
